import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { TABLE_ROWS_PER_PAGE } from "../../../utils/Constants";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import PermissionsGate from "../../../utils/permissionGate";
import hasPermission from "../../../utils/hasMultiplePermission";
import Tablefilter from "../../common/Tablefilter";
import { RenderQuizTopic, RenderstaticPagesBrandList, RenderStaticPagesStatus, RenderWebsitelistStatus, RenderWebsitelistType } from "../../../utils/CommonStatusItems";
import axios from "axios";
import { handleTableScroll } from "../../../utils/commonFunction";
import $ from "jquery";
import { DeleteWebsiteList } from "../../../services/WebsiteListServer";
import { DeleteStaticPages, GetStaticPageList, GetStaticPageListCancelToken, GetStaticPagesListsFilterCancelToken } from "../../../services/StaticPgesServer";
import { popupConfirmDeleteWarning } from "../../../utils/Popups";
import { usePermissionGuard } from "../../../hooks/usePermissionGuard";

function StaticPagesTable() {

    const history = useHistory();
    const [search, setSearch] = useState("");
    const [debouncedTerm, setDebouncedTerm] = useState("");
    const [status, setStatus] = useState({ arr: [], checkObj: {} });
    const [brand, setBrand] = useState({ arr: [], checkObj: {} });
    const [type, setType] = useState({ arr: [], checkObj : {} });
    const [searchStatusCheck, setSearchStatusCheck] = useState({});
    const givenPermsisions = useSelector((state) => state.givenPermission);
    const [deleterow, setDeleteRow] = useState(false);
    const [staticPagesData, setStaticPagesData] = useState([]);
    const [loading, setloading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [updateData, setUpdateData] = useState(true);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [sortkey, setSortKey] = useState("CreatedTimestamp");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [filterUrl,setFilterUrl] = useState({arr : [], checkObj : {} });
    const [filterData, setFilterData] = useState({ status: [], brand: [], type: [],url: []});


    useEffect(() => {
        handleTableScroll()
    }, [loading])

    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });
    })

    useEffect(() => {
        const storedFilters = JSON.parse(localStorage.getItem("filterStaticpages"));
        if (storedFilters) {
            setStatus(storedFilters.status);
            setBrand(storedFilters.brand);
            setType(storedFilters.type);
        }
    }, []);

    useEffect(() => {
        const filterState = {
            status,
            brand,
            type
        };
        localStorage.setItem("filterStaticpages", JSON.stringify(filterState));
    }, [status, brand,type]);

    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });

    })

    const handleSort = (column, sortDirection) => {
        setSortKey(column.sortField);
        setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
    };

    useEffect(() => {
        const cancelTokenSources = [];

        const getStaticPageList = async () => {
            setloading(true);

            cancelTokenSources.forEach(source => {
                source.cancel('New request made');
            });

            const source = axios.CancelToken.source();
            cancelTokenSources.push(source);

            const staticPage = {
                page: page,
                perPage: perPage,
                key: sortkey,
                sort: sortOrder,
                search: search,
                viaStatus: status.arr,
                viaBrand: brand?.arr,
                viaType: type?.arr,
                viaUrl: filterUrl.arr
            };

            try {
                const res = await GetStaticPageListCancelToken(staticPage, source.token);
                setStaticPagesData(res?.data?.Data?.data);
                setTotalRows(res.data?.Data?.total);
                setPerPage(res.data?.Data?.perPage);
                if (res.status == 200) {
                    setloading(false);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                    setloading(false);
                }
            }
        }

        getStaticPageList();

        return () => {
            cancelTokenSources.forEach(source => {
                source.cancel('Component unmounted');
            });
        };
    }, [page, perPage, sortOrder, sortkey, search,filterUrl, status, brand,type, searchStatusCheck, updateData]);

    useEffect(() => {
        const dropdownSource = axios.CancelToken.source();

        const fetchData = async () => {
            try {
                const res = await GetStaticPagesListsFilterCancelToken(dropdownSource.token);

                setFilterData({
                    status: res?.data?.getStatus,
                    brand: res?.data?.getBrandtemplate,
                    type : res?.data?.typeFilterList,
                    url : res?.data?.urlFilterList,
                })
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            }
        };

        fetchData();

        return () => {
            dropdownSource.cancel('Component unmounted');
        };
    }, []);

    usePermissionGuard({
        scopes: ['sview'],
        onNoAccess: () => {
            history.push('/noaccess');
        },
        dependencies: [deleterow]
    });

    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setDebouncedTerm(value);
    };

    const resetFilter = () => {
        setStatus({ arr: [], checkObj: {} });
        setBrand({ arr: [], checkObj: {} });
        setType({ arr: [], checkObj: {} });
        setFilterUrl({ arr: [], checkObj: {} });
        setSearchStatusCheck({});
        setSearch("");
        setDebouncedTerm("");
    };

    useEffect(() => {
        return resetFilter()
    }, [])

    const handlePageChange = (pageNo) => {
        setPage(pageNo);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
    };

    const handleRedirection = (ID) => {
        if (hasPermission({ scopes: ["sgiview"], permissions: givenPermsisions })) {
            return `/studentAdministration/students/open/${ID}/general`;
        } else if (
            hasPermission({ scopes: ["spiview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/personal`;
        } else if (
            hasPermission({ scopes: ["sedview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/education`;
        } else if (
            hasPermission({ scopes: ["sapiview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/account`;
        } else if (
            hasPermission({ scopes: ["scpview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/coursesAndProgramme`;
        } else if (
            hasPermission({ scopes: ["sasview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/assessments`;
        } else if (
            hasPermission({ scopes: ["snview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/notifications`;
        } else if (
            hasPermission({ scopes: ["scaview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/classAttendance`;
        } else if (
            hasPermission({ scopes: ["slview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/licenses`;
        } else if (
            hasPermission({ scopes: ["scview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/certificates`;
        } else if (
            hasPermission({ scopes: ["saview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/appeals`;
        } else if (
            hasPermission({ scopes: ["stview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/tickets`;
        } else if (
            hasPermission({ scopes: ["snoview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/notes`;
        } else {
            return `/studentAdministration/students/open/${ID}/auditTrail/employee`;
        }
        // history.push(redirectLink)
    };

    const handleDelete = (id) => {
        popupConfirmDeleteWarning((result) => {
            if (result.isConfirmed) {
                DeleteStaticPages(id)
                    .then((res) => {
                        Swal.fire("Deleted!", "Static Page has been deleted.", "success");
                        setUpdateData(!updateData);
                    })
                    .catch((error) => console.log(error));
            }
        });
    }

    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "PageTitle",
            sortField: "PageTitle",
            sortable: true,
            cell: (row) => (
                <div>
                    <PermissionsGate scopes={["wbsstaticpageedit"]} RenderError={() => <p>{row?.PageTitle}</p>}>
                    <Link
                        className="as-text-blue curser feature-name"
                        to={`/website_management/pages/staticpages/table/update/${row.PageID}`}
                        title={row.PageTitle}
                    >
                        <span className="textLimit100">{row.PageTitle}</span>
                    </Link>
                    </PermissionsGate>
                </div>
            ),
        },
        {
            name: "Status",
            selector: "status",
            sortField: "status",
            sortable: true,
            cell: (row) => (row.status != null ? RenderWebsitelistStatus(row.status).html : "-"),
        },
        {
            name: "Type",
            selector: "type",
            sortField: "type",
            sortable: true,
            cell: (row) => (RenderWebsitelistType(row?.type)?.html)
        },
        {
            name: "Brand Templates",
            selector: "brandTemplete",
            sortField: "brandTemplete",
            cell: (row) =>
                row?.brandTemplete && row?.brandTemplete.length ? (
                    <div className="d-flex flex-wrap">
                        {row?.brandTemplete.map((item) => (
                            <span key={`${item.templateName}_${item.PageID}`} className="mr-1">
                                {/* Assuming RenderQuizTopic returns an object with html property */}
                                {RenderQuizTopic(item.templateName).html}
                            </span>
                        ))}
                    </div>
                ) : (
                    "-"
                ),
        },
        {
            name: "URL",
            selector: "url",
            sortField: "url",
            sortable: true,
            cell: (row) => (row.url ? <>/{row.url}</> : "-"),
        },
        {
            name: "Last Edited",
            selector: "LastUpdateTimestamp",
            sortField: "LastUpdateTimestamp",
            sortable: true,
            cell: (row) => {
                let dateString = row.LastUpdateTimestamp;
                if (dateString) {
                    let dateObj = new Date(dateString);
                    let day = ('0' + dateObj.getDate()).slice(-2);
                    let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    let month = monthNames[dateObj.getMonth()];
                    let year = ('' + dateObj.getFullYear()).slice(-2);
                    let formattedDate = `${day} ${month} ${year}`;
            
                    return <div title={formattedDate}>{formattedDate}</div>;
                }
            
                return null; 
            },
        },
        {
            name: "Created Date",
            selector: "CreatedTimestamp",
            sortField: "CreatedTimestamp",
            sortable: true,
            cell: (row) => {
                let dateString = row.CreatedTimestamp;

                if (dateString) {
                    let dateObj = new Date(dateString);
                    let day = ('0' + dateObj.getDate()).slice(-2);
                    let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    let month = monthNames[dateObj.getMonth()];
                    let year = ('' + dateObj.getFullYear()).slice(-2);
                    let formattedDate = `${day} ${month} ${year}`;
            
                    return <div title={formattedDate}>{formattedDate}</div>;
                }

                return null; 
            },
        },
        {
            name: "Actions",
            selector: "",
            // maxWidth: "50px",
            cell: (row) => (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons d-flex">
                        <PermissionsGate scopes={['wbsstaticpageedit']} RenderError={() => (
                            <button
                                className="btn btn-primary rounded-circle"
                                title="Open"
                                disabled
                            >
                                <i className="fal fa-folder-open"></i>
                            </button>
                        )}>

                        <Link
                            className="btn btn-primary rounded-circle"
                            to={`/website_management/pages/staticpages/table/update/${row.PageID}`}
                            title="Open"
                            >
                            <i className="fal fa-folder-open"></i>
                        </Link>
                        </PermissionsGate>
                        {row?.type == 0 && (
                        <PermissionsGate scopes={['wbsstaticpagedelete']} RenderError={() => (
                            <button
                                className="btn btn-danger rounded-circle"
                                title="Open"
                                disabled
                            >
                               <i className="fal fa-trash-alt"></i>
                            </button>
                        )}>


                        <button
                            className="btn btn-danger rounded-circle"
                            onClick={() => handleDelete(row.PageID)}
                            title="Delete"
                            >
                            <i className="fal fa-trash-alt"></i>
                        </button>
                        </PermissionsGate>
                        )}
                    </div>
                </div>
            ),
        },
    ]);

    // TODO Excel
    // TODO Csv
    // TODO Pdf

    const exportData = (fileType, fileName) => {
        let data = [];
        const header = ["Name", "Status", "Type", "Brand Templates","URL", "Last Edited", "Created Date"];
        Swal.fire({
            title: "File downloading",
            onOpen: function () {
                Swal.showLoading();
            },
        });

        const staticPagesData = {
            key: sortkey,
            sort: sortOrder,
            search: search,
            viaStatus: status.arr,
            viaBrand: brand.arr,
            viaType: type.arr,    
            viaUrl: filterUrl.arr,                                                                                                                                                                                                                                                                                                                                                        
            exportStatus: "true",
        };

        GetStaticPageList(staticPagesData)
            .then((res) => {
                data = res?.data?.Data;
                // console.log(res?.data?.Data);

                data = data?.map((row) => {
                    let dateString = row.CreatedTimestamp;
                    let dateObj = new Date(dateString);
                    let day = ('0' + dateObj.getDate()).slice(-2);
                    let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    let month = monthNames[dateObj.getMonth()];
                    let year = ('' + dateObj.getFullYear()).slice(-2);
                    let formattedDate = `${day} ${month} ${year}`;

                    let lastdateString = row.LastUpdateTimestamp;
                    let lastdateObj = new Date(lastdateString);
                    let lastday = ('0' + lastdateObj.getDate()).slice(-2);
                    let lastmonth = monthNames[lastdateObj.getMonth()];
                    let lastyear = ('' + lastdateObj.getFullYear()).slice(-2);
                    let formattedLastDate = `${lastday} ${lastmonth} ${lastyear}`;

                    const brandTemplate = row.brandTemplete?.map((item) => item.templateName).join(",");

                    return ({
                        ...row,
                        Name: row?.PageTitle ? row?.PageTitle : "-",
                        Status: row?.status != null ? RenderWebsitelistStatus(row.status).text : "-",
                        Type: row?.type !== null ? RenderWebsitelistType(row.type).text : "-",
                        "Brand Templates": row.brandTemplete.length > 0 ? row.brandTemplete.map((item)=> item.templateName).join(", ") : "-",
                        "URL": row?.url || "-",
                        "Last Edited": row.LastUpdateTimestamp ? formattedLastDate : "-",
                        "Created Date": row.CreatedTimestamp ? formattedDate : "-",
                    })
                });

                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data });
                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8,",
                    });

                    const blobURL = window.URL.createObjectURL(blob);

                    // Create new tag for download file
                    const anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = blobURL;
                    anchor.dataset.downloadurl = [
                        "text/csv",
                        anchor.download,
                        anchor.href,
                    ].join(":");
                    anchor.click();

                    // Remove URL.createObjectURL. The browser should not save the reference to the file.
                    setTimeout(() => {
                        // For Firefox it is necessary to delay revoking the ObjectURL
                        URL.revokeObjectURL(blobURL);
                    }, 1000);
                    Swal.close();
                } else if (fileType === "xlsx") {
                    const compatibleData = data.map((row) => {
                        const obj = {};
                        header.map((col, index) => {
                            obj[col] = row[col];
                        });
                        return obj;
                    });

                    let wb = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                        header,
                    });
                    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);
                    Swal.close();
                    // Returning false as downloading of file is already taken care of
                    return false;
                }
                if (fileType === "pdf") {
                    const compatibleData = data?.map((row) => {
                        let dateString = row.CreatedTimestamp;
                        let dateObj = new Date(dateString);
                        let day = ('0' + dateObj.getDate()).slice(-2);
                        let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                        let month = monthNames[dateObj.getMonth()];
                        let year = ('' + dateObj.getFullYear()).slice(-2);
                        let formattedDate = `${day} ${month} ${year}`;

                        let lastdateString = row.LastUpdateTimestamp;
                        let lastdateObj = new Date(lastdateString);
                        let lastday = ('0' + lastdateObj.getDate()).slice(-2);
                        let lastmonth = monthNames[lastdateObj.getMonth()];
                        let lastyear = ('' + lastdateObj.getFullYear()).slice(-2);
                        let formattedLastDate = `${lastday} ${lastmonth} ${lastyear}`;

                        const brandTemplate = row.brandTemplete?.map((item) => item.templateName).join(",");

                        return [
                            row?.PageTitle ? row?.PageTitle : "-",
                            row?.status ? RenderWebsitelistStatus(row.status).text : "-",
                            row?.type !== null ? RenderWebsitelistType(row.type).text : "-",
                            row.brandTemplete.length > 0 ? row.brandTemplete.map((item)=> item.templateName).join(", ") : "-",
                            row.url || "-",
                            row.LastUpdateTimestamp ? formattedLastDate : "-",
                            row.CreatedTimestamp ? formattedDate : "-",
                        ];
                    });
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: compatibleData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            // valign: "center",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);
                    Swal.close();
                    return false;
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
        return () => {
            clearTimeout(timer);
        }
    }, [debouncedTerm])

    return (
        <div className="my-tickets-info-list Tickets-main-wrap">
            <div className="custom-table-div filter-search-icon card card-table-custom program-table">
                <div className="search-filter-div">
                    <div className="search-filter-div-left">
                        <div className="system-administration-table table-responsive">
                            <div className="table-responsive-div">
                                <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                                    <div id="assessment-table-main_filter" className="dataTables_filter">
                                        <label>
                                            <input
                                                type="search"
                                                className=""
                                                placeholder="Search"
                                                aria-controls="assessment-table-main"
                                                onChange={handleSearchFilter}
                                                value={debouncedTerm}
                                            />
                                        </label>
                                        <div className="filter-eff filter-data-btn">
                                            <button className="filter-buttons">
                                                <i className="fal fa-filter"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-button-group">
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Status"
                                            optionArr={filterData?.status}
                                            state={status}
                                            setState={setStatus}
                                            stopOptionSorting={true}
                                            isOptionReversed={false}
                                            renderLabelFunction={RenderWebsitelistStatus}
                                        />
                                    </div>
                                </div>
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Brand Templates"
                                            optionArr={filterData?.brand}
                                            state={brand}
                                            setState={setBrand}
                                            stopOptionSorting={true}
                                            isOptionReversed={false}
                                            // renderLabelFunction={RenderstaticPagesBrandList}
                                        />
                                    </div>
                                </div>
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="Type"
                                            optionArr={filterData?.type}
                                            state={type}
                                            setState={setType}
                                            renderLabelFunction={RenderWebsitelistType}
                                            uniqueId="staticType"
                                            // renderLabelFunction={RenderstaticPagesBrandList}
                                        />
                                    </div>
                                </div>
                                <div className="filter-scroll">
                                    <div className={`filter-scroll-inner filter-custom-new`}>
                                        <Tablefilter
                                            filterName="URL"
                                            optionArr={filterData?.url}
                                            state={filterUrl}
                                            setState={setFilterUrl}
                                            // renderLabelFunction={RenderstaticPagesBrandList}
                                        />
                                    </div>
                                </div>
                                <div className="reset-btn-group">
                                    <div className="button-reset dropdown-comman">
                                        <button
                                            className="btn btn-primary"
                                            onClick={resetFilter}
                                            title="Reset"
                                        >
                                            <i className="fal fa-redo"></i>Reset
                                        </button>
                                    </div>
                                    <div className="files-export-group">
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("xlsx", "Static Pages List");
                                            }}
                                            title="Export spreadsheet"
                                        >
                                            <i className="fal fa-file-excel icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("csv", "Static Pages List");
                                            }}
                                            title="Export CSV"
                                        >
                                            <i className="fal fa-file-csv icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("pdf", "Static Pages List");
                                            }}
                                            title="Export PDF"
                                        >
                                            <i className="fal fa-file-pdf icon"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="search-filter-div-right">
                        <div className=" filter-search-bar-blk">
                            <div className="add-ticket-blk button-reset dropdown-comman">
                                <PermissionsGate
                                    RenderError={() => (
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            title="Create new"
                                            disabled
                                        >
                                            <i className="fal fa-plus"></i>Create New
                                        </button>
                                    )}
                                    scopes={["wbsstaticpageadd"]}
                                >
                                    <Link to={`/website_management/pages/staticpages/table/create`}>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            title="Create new"
                                        >
                                            <i className="fal fa-plus"></i>Create New
                                        </button>
                                    </Link>
                                </PermissionsGate>
                            </div>
                        </div>
                    </div>
                </div>
                <DataTable
                    paginationDefaultPage={page}
                    progressPending={loading}
                    data={staticPagesData}
                    progressComponent={<SkeletonTicketList />}
                    defaultSortField={sortkey}
                    defaultSortAsc={false}
                    columns={columns}
                    pagination={true}
                    // noDataComponent={Str.noRecord}
                    onSort={handleSort}
                    sortServer
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    highlightOnHover={false}
                    paginationPerPage={perPage}
                    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
                />
            </div>
        </div>
    );
}

export default StaticPagesTable;
